<template>
  <div
    data-component-group="invoice-form"
    data-component="edit"
    class="elevation-1"
  >
    <div class="component-body">
      <InvoiceForm
        :invoice="invoice"
        confirm-trigger-label="Update invoice"
        :is-disabled="true"
        :is-loading="isLoading"
        :on-submit="() => {}"
      >
        <template v-slot:beforeForm>
          <layout-section-header title="Details" :has-trigger="false" />
        </template>
      </InvoiceForm>

      <div class="invoice-pdf">
        <layout-section-header
          title="Invoice PDF"
          trigger-label="Download"
          class="elevation-1"
          @toggle="onDownloadPdf"
        />
      </div>

      <PaymentForm
        :invoice="invoice"
        confirm-trigger-label="Update payment"
        :is-disabled="!canEditAmount"
        :is-loading="isLoading"
        :on-submit="onSubmit"
      >
        <template v-slot:beforeForm>
          <layout-section-header
            title="Payment information"
            :has-trigger="false"
          />
          <!-- this may return -->
          <!-- <layout-section-header
            title="Payment information"
            :has-trigger="$ability.can('update', 'invoice')"
            :trigger-label="!canEditAmount ? 'Edit information' : 'Close'"
            @toggle="toggleEditAmount"
          /> -->
        </template>
      </PaymentForm>

      <InvoiceLines :items="invoiceLines" :currency="invoiceCurrency">
        <template v-slot:beforeForm>
          <layout-section-header title="Invoice lines" :has-trigger="false" />
        </template>
      </InvoiceLines>

      <Totals :invoice="invoice">
        <template v-slot:beforeForm>
          <layout-section-header title="Totals" :has-trigger="false" />
        </template>
      </Totals>
    </div>
  </div>
</template>

<script>
  import InvoiceForm from './AddNew';
  import PaymentForm from './Payment';
  import Totals from './Totals';
  import InvoiceLines from '../../lists/InvoiceLines';
  import defaultPagination from '../../../config/pagination';
  import { isObj } from '../../../utils';

  // TODO: Translate component

  export default {
    components: {
      InvoiceForm,
      PaymentForm,
      Totals,
      InvoiceLines,
    },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        pagination: {
          ...defaultPagination,
        },
        canEditAmount: false,
        isUpdatingDiscount: false,
      };
    },
    computed: {
      invoiceLines() {
        const { lines = [] } = this.invoice || {};
        return lines;
      },
      invoiceCurrency() {
        const { currency = {} } = this.invoice.cost_center || {};
        return currency;
      },
    },
    watch: {
      invoice(nextInvoice) {
        if (isObj(nextInvoice)) {
          this.canEditAmount = false;
          this.pagination = defaultPagination;
        }
      },
    },
    methods: {
      toggleEditAmount() {
        this.canEditAmount = !this.canEditAmount;
      },
      onDownloadPdf() {
        const { id, invoice_number } = this.invoice;
        const query = { id, invoice_number };

        return this.$store.dispatch('invoices/generatePdf', query);
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='invoice-form'][data-component='edit'] {
  .v-btn {
    margin: 0;
  }

  .invoice-pdf {
    [data-component='section-header'] {
      padding: $spacing-xl;
      background-color: map.get($colors, shades, 'white');
      border-top: 1px solid map.get($colors, grey, lighten-2);
    }
  }
}
</style>
